module.exports = __webpack_public_path__ + "static/media/Project3_HeaderImg.f9851ddd.png";